import {
    type LensCtaDeeplinkInput,
    type LensCtaWebsiteInput,
    type MyLensesLensCta,
    type MyLensesLensCtaInput,
} from "../../gql-generated/types";

export const makeLensCtaInput = (lensCta: MyLensesLensCta): MyLensesLensCtaInput | null => {
    if (lensCta.website) {
        const { url } = lensCta.website;
        const lensCtaWebsiteInput: LensCtaWebsiteInput = {
            url,
        };
        return {
            type: lensCta.type,
            text: lensCta.text,
            website: lensCtaWebsiteInput,
        };
    } else if (lensCta.deeplink) {
        const { uri, appName, iosAppId, androidAppUrl } = lensCta.deeplink;
        const lensCtaDeeplinkInput: LensCtaDeeplinkInput = {
            uri,
            appName,
            iosAppId,
            androidAppUrl,
        };

        return {
            type: lensCta.type,
            text: lensCta.text,
            deeplink: lensCtaDeeplinkInput,
        };
    }
    return null;
};
